import { useService } from 'react-reservice';

import { getLightBackgroundColor } from '@aqx-core/common/utils/color';

import { EAppThemeMode } from '../types';
import { appThemeService } from './service';

export const useAppTheme = () => useService(appThemeService, (context) => context);

/**
 * Returns white in light mode and background.default in dark mode.
 * Used for icon/element foreground colors that sit on top of a colored background.
 */
export const useThemeContrastColor = () =>
  useService(appThemeService, ({ theme }) =>
    theme.themeMode === EAppThemeMode.LIGHT ? theme.themeColors.white : theme.themeColors.background.default
  );

export const useBuySellTagColors = (isBuyOrder: boolean) =>
  useService(appThemeService, (context) => {
    const { theme } = context;
    const baseColor = isBuyOrder ? theme.themeColors.pnl.positive.default : theme.themeColors.pnl.negative.default;
    const backgroundColor = getLightBackgroundColor(baseColor, theme.themeMode);
    return {
      textColor: baseColor,
      backgroundColor
    };
  });
